export default function DataSourceService({ baseUrl, http }) {
  const PATH_GENERIC_INFO = '/api/info';
  const PATH_COUNTRIES = '/api/locations/countries';
  const PATH_CHAINS = '/api/locations/chains';
  const PATH_STORES = '/api/locations/stores';
  const PATH_SESSIONS = '/api/ppl/sessions/list';
  const PATH_AISLES = '/api/ppl/aisle';
  const PATH_IMAGES = '/api/visualize/images_metadata';
  const PATH_SOURCES = '/api/visualize/sources';
  const PATH_LAYOUT_IDS = '/api/visualize/layout_ids';
  const SIGN_IMAGE = '/api/visualize/sign_image';
  const PATH_DOWNLOAD_IMAGE = '/api/visualize/download_image';
  const PATH_DETECTIONS_BY_VALUE = '/api/visualize/detection_id_by_value';
  const PATH_CONSOLIDATION_STAGES = '/api/visualize/walls/stages';
  const PATH_IMAGE_PROPOSAL = '/api/image/proposal'
  const PATH_PROMOTIONAL_SIGNAGE_IMAGE = '/api/visualize/promotional_signage_image'
  const PATH_METADATA_DESCRIPTION = '/api/ops/walls/metadatadescription'

  return {
    getGenericInfo,
    getCountries,
    getChains,
    getStores,
    getSessions,
    getAisles,
    getImages,
    signImage,
    getDetectionsByValue,
    getConsolidationStages,
    getLabelImage,
    getMetadataDescription,
    getPromotionalSignageImage,
    getSources,
    getLayoutIds,
    downloadImage,
  };

  function getGenericInfo({ info }) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_GENERIC_INFO}`,
      body: {
        info,
      },
    });
  }

  function getCountries() {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_COUNTRIES}`,
    });
  }

  function getChains() {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_CHAINS}`,
    });
  }

  function getStores(payload) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_STORES}`,
      query: {
        country_id: payload.country_id,
        chain_id: payload.chain_id,
      },
    });
  }

  function getSessions(store, useBifrost) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_SESSIONS}/${store}/${useBifrost}`,
    });
  }

  function getAisles(session, store, useBifrost) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_AISLES}/${session}/${useBifrost}/${store}`,
    });
  }

  function getImages(payload) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_IMAGES}`,
      body: payload,
    });
  }

  function signImage(payload) {
    return http.postAuthenticated({
      url: `${baseUrl}${SIGN_IMAGE}`,
      body: payload,
    });
  }

  function getDetectionsByValue(payload) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_DETECTIONS_BY_VALUE}`,
      body: payload,
    });
  }

  function getConsolidationStages(payload) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_CONSOLIDATION_STAGES}`,
      body: payload,
    });
  }

  function getLabelImage(store, session, detection_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_IMAGE_PROPOSAL}/${store}/${session}/${detection_id}`,
    });
  }

  function getMetadataDescription() {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_METADATA_DESCRIPTION}`,
    });
  }

  function getPromotionalSignageImage(store, session, detection_id) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_PROMOTIONAL_SIGNAGE_IMAGE}`,
      query: { store, session, detection_id }
    });
  }

  // Sources
  function getSources(session, objectType) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_SOURCES}`,
      query: { session, object_type: objectType },
    });
  }

  // Layout ids
  function getLayoutIds({
    store,
    session,
    objectType,
    aiType,
    aisle,
    collector,
  }) {
    return http.getAuthenticated({
      url: `${baseUrl}${PATH_LAYOUT_IDS}`,
      query: {
        store,
        session,
        object_type: objectType,
        ia_type: aiType,
        ...(aisle ? { aisle } : {}),
        collector,
      },
    });
  }

  // Image download
  function downloadImage({
    store,
    session,
    blobPath,
    aiType,
    imageId,
    imageType,
  }) {
    return http.postAuthenticated({
      url: `${baseUrl}${PATH_DOWNLOAD_IMAGE}`,
      body: {
        store,
        session,
        blob_path: blobPath,
        ai_type: aiType,
        image_id: imageId,
        image_type: imageType,
      },
    });
  }
}
